import axios from "axios";
import { buildRegistrationPayload } from "./registrationPayload";

const registrationApi = axios.create({
  baseURL: "https://f1.tudo.art.br/api/v1",
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    "X-Api-Key": import.meta.env.VITE_F1_API_KEY,
  },
  timeout: 10000,
});

export async function validateRegistration(credentials) {
  const response = await registrationApi.post("/inscricoes/validar", {
    ibm: credentials.ibm.trim(),
    email: credentials.email.trim().toLowerCase(),
  });

  return response.data;
}

export async function getRegistrationByIbm(ibm) {
  const response = await registrationApi.get(`/inscricoes/${encodeURIComponent(ibm.trim())}`);
  return response.data;
}

export async function submitRegistration(data) {
  try {
    const response = await registrationApi.post("/inscricoes", buildRegistrationPayload(data), {
      headers: { "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8" },
    });

    if (response.data?.ok === false) {
      throw new Error(response.data.message || "Não foi possível concluir o cadastro.");
    }

    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const validationErrors = error.response?.data?.errors;
      const fieldMessage = validationErrors
        ? Object.values(validationErrors).flat().find((message) => typeof message === "string")
        : "";
      const message = fieldMessage || error.response?.data?.message || "Não foi possível concluir o cadastro. Tente novamente.";
      throw new Error(message, { cause: error });
    }

    throw error;
  }
}

export function getValidationErrorMessage(error) {
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 404) {
      return "IBM e e-mail não encontrados. Confira os dados informados.";
    }

    if (error.code === "ECONNABORTED") {
      return "A validação demorou mais que o esperado. Tente novamente.";
    }

    return error.response?.data?.message || "Não foi possível validar os dados. Tente novamente.";
  }

  return "Não foi possível validar os dados. Tente novamente.";
}

export function getIbmValidationErrorMessage(error) {
  if (axios.isAxiosError(error)) {
    if (error.response?.status === 404) {
      return "IBM não encontrado na lista de liberados.";
    }

    if (error.code === "ECONNABORTED") {
      return "A validação do IBM demorou mais que o esperado. Tente novamente.";
    }

    return error.response?.data?.message || "Não foi possível validar o IBM. Tente novamente.";
  }

  return "Não foi possível validar o IBM. Tente novamente.";
}
